import { requestRoot } from '@/axios';

const endpoint = '/game';

export const getGameList = (page, limit) => {
  let url = endpoint;
  if (page !== undefined && limit !== undefined) {
    url = `${endpoint}/?page=${page}&limit=${limit}`;
  }
  return requestRoot.get(url);
};

export const getGamesByCategory = ({ skip, limit, category }) => {
  let url = `${endpoint}/category`;
  if (skip !== undefined && limit !== undefined) {
    url = `${url}/?skip=${skip}&limit=${limit}&category=${category}`;
  }
  return requestRoot.post(url);
};

export const getGameById = id => requestRoot.get(`${endpoint}/${id}`);
